<template>
  <v-container>
    <img src="../../assets/breadcrumb1.svg" />

    <h1 class="title mt-2">What is your business address?</h1>
    <h2 class="subheading">
      Enter the physical address of your company including the suite number if applicable. The
      company address can be anywhere in the U.S. but it cannot be a PO box. If you run a home based
      business, you may enter your home address.
    </h2>
    <v-form ref="form">
      <v-text-field
        v-model="address"
        :rules="[required]"
        label="Address"
        browser-autocomplete="street-address"
        required
        data-cy="address"
      />
      <v-text-field
        v-model="city"
        :rules="[required]"
        label="City"
        browser-autocomplete="address-level2"
        required
        data-cy="city"
      />
      <v-autocomplete
        v-model="state"
        :items="states"
        :rules="[required]"
        label="State"
        browser-autocomplete="address-level1"
        required
        data-cy="state"
      />
      <v-text-field
        v-model="zip"
        :rules="[required]"
        label="Zip Code"
        browser-autocomplete="postal-code"
        required
        data-cy="zip"
      />
      <v-layout justify-space-around>
        <v-btn @click="$router.go(-1);">Back</v-btn>
        <v-btn color="info" @click="done">Continue</v-btn>
      </v-layout>
    </v-form>
  </v-container>
</template>

<script>
import firebase from 'firebase/app';
import 'firebase/database';
import { mapState } from 'vuex';
import { omit } from 'lodash-es';
import { states } from '../util';

const db = firebase.database;

export default {
  data: () => ({
    address: '',
    city: '',
    state: '',
    states,
    zip: '',
  }),
  computed: mapState(['token', 'type']),
  methods: {
    async done() {
      if (!this.$refs.form.validate()) return;
      await db()
        .ref(`info/${this.token}/business`)
        .update(omit(this.$data, 'states'));
      this.$router.push({ path: `managed${this.type}` });
    },
    required: field => !!field || 'This field is required',
  },
};
</script>
